import { Routes, Route, useLocation } from "react-router";
import { useSelector } from "react-redux";

// Constants
import { ROUTE} from "../../../constants";

/**
 * Components
 */
import { asyncComponent } from "../../../components";

/**
 * Pages
 */
import SSOPanel from "../../../pages/SSOPanel";
import SSOLoading from "../../../pages/SSOLoading";
import SSOLogin from "../../../pages/SSOLogin";
import {
  SSOForgotPassword,
  SSOForgotPassword6DigitsCode,
  SSOForgotPasswordNewPassword,
  SSOForgotPasswordChanged,
} from "../../../pages/SSOResetCredential";

// Styles

const AsyncNotFoundPage = asyncComponent(() =>
  import("../../../pages/NotFoundPage")
);

const AuthSelector = () => {
  const auth = useSelector((state) => state.root.auth);

  const _authSelector = () => {
    if (auth.loadingState) {
      return <SSOLoading />;
    } else {
      if (auth.currentUser) {
        return <SSOPanel currentUser={auth.currentUser} />;
      } else {
        return <SSOLogin />;
      }
    }
  };

  return <>{_authSelector()}</>;
};

const SSORoutes = () => {
  const location = useLocation();

  const { state = {} } = location;
  const verify = state && state.verify;
  const authid = state && state.authid;

  return (
    <>
      <Routes>
        <Route
          exact
          path={ROUTE.MODULE_ROUTE.Login}
          element={<AuthSelector />}
        />

        <Route
          index
          path={ROUTE.MODULE_ROUTE.Landing_Page}
          element={<AuthSelector />}
        />

        <Route
          exact
          path={ROUTE.MODULE_ROUTE.FORGOT_PASSWORD}
          element={<SSOForgotPassword />}
        />

        <Route
          exact
          path={ROUTE.MODULE_ROUTE.FORGOT_PASSWORD_6_DIGITS_CODE}
          element={<SSOForgotPassword6DigitsCode />}
        />

        {verify && authid && (
          <Route
            exact
            path={ROUTE.MODULE_ROUTE.FORGOT_PASSWORD_NEW_PASSWORD}
            element={<SSOForgotPasswordNewPassword authid={authid} />}
          />
        )}

        <Route
          exact
          path={ROUTE.MODULE_ROUTE.FORGOT_PASSWORD_SUCCESS}
          element={<SSOForgotPasswordChanged />}
        />

        <Route element={<AsyncNotFoundPage />} />
      </Routes>
    </>
  );
};

export default SSORoutes;
